module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-21-min.2890494a.jpg";